<template>
<div v-if="inputData.inputVisible">
    <label v-if="inputData.withLabel" class="form-label" :for="inputData.inputID">{{inputData.labelTxt}}</label>
    <div ref="txtInput" class="txt-input" :class="{'txt-input-invalid': hasError}" :for="inputData.inputID" :data-char-count="inputData.charCount">
        <div v-if="inputData.showCharCount" class="txt-char-count">{{charCount}}</div>
        <div v-if="inputData.removeInputBtn" @click="removeInput" class="input-close-btn"></div>
        <input
            type="text"
            autocomplete="off"
            v-model="txtInputData"
            :id="inputData.inputID"
            :placeholder="inputData.placeHolderTxt"
            :maxlength="inputData.maxCharLength"
            @focus="countInputChars(inputData)"
            @blur="clearCharCount(inputData); validateInput()"
            @change="countInputChars(inputData); sendTxtValue();"
            @keydown="countInputChars(inputData); sendTxtValue();"
            :ref="inputData.id"
        />
    </div>
</div>

</template>

<script>
export default {
    name: "formTxtInput",
    props: {
        inputData: Object,
    },
    data() {
        return {
            txtInputData: "",
            charCount: "",
            inputValidation: false,
            hasError: false,
        }
    },
    methods: {
        sendTxtValue() {
            this.$emit('txtvalue', this.txtInputData);
        },
        countInputChars(element) {
            if (element.showCharCount) {
                this.charCount = this.txtInputData.length + '/' + element.maxCharLength;
            }
        },
        clearCharCount(element) {
            if (element.showCharCount) {
                this.charCount='';
            }
        },
        removeInput() {
            this.$emit('removeInput');
        },
        validateInput() {
            if (this.inputValidation) {
                let inputElement = this.$refs["txtInput"];
                if (this.txtInputData === "" && !inputElement.classList.contains('txt-input-invalid')) {
                    this.hasError = true;
                }
                if (this.txtInputData !== "" && inputElement.classList.contains('txt-input-invalid')) {
                    this.hasError = false;
                }
            }
        }
    },
    mounted() {
        // auto focus on input when added
        if (this.inputData.autoFocus) {
            this.$refs[this.inputData.id].focus();
        }
        
        this.inputValidation = this.inputData.inputValidation;
        
        this.sendTxtValue();
    }
}
</script>

<style>

</style>